var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.66
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6953,
    cy: 60.4023,
    r: 60,
    fill: "url(#paint0_radial_1209_34109)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 60.6953,
    cy: 60.4023,
    r: 32,
    fill: "#7551FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 60.6953,
    cy: 60.4023,
    r: 35.6048,
    stroke: "#7551FF",
    strokeWidth: 0.790345
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4427 50.1589C59.7063 50.1589 59.1094 50.7558 59.1094 51.4922C59.1094 53.7485 56.3814 54.8785 54.7859 53.283C54.2652 52.7623 53.421 52.7623 52.9003 53.283C52.3796 53.8037 52.3796 54.648 52.9003 55.1687C54.4958 56.7642 53.3657 59.4922 51.1094 59.4922C50.373 59.4922 49.776 60.0891 49.776 60.8255C49.776 61.5619 50.373 62.1589 51.1094 62.1589C53.3659 62.1589 54.4956 64.887 52.9002 66.4824C52.3795 67.0031 52.3795 67.8473 52.9002 68.368C53.4209 68.8887 54.2651 68.8887 54.7858 68.368C56.3812 66.7726 59.1094 67.9024 59.1094 70.1589C59.1094 70.8952 59.7063 71.4922 60.4427 71.4922C61.1791 71.4922 61.776 70.8952 61.776 70.1589C61.776 67.9025 64.5041 66.7725 66.0996 68.368C66.6203 68.8887 67.4645 68.8887 67.9852 68.368C68.5059 67.8473 68.5059 67.0031 67.9852 66.4824C66.3898 64.8869 67.5196 62.1589 69.776 62.1589C70.5124 62.1589 71.1094 61.5619 71.1094 60.8255C71.1094 60.0891 70.5124 59.4922 69.776 59.4922C67.5198 59.4922 66.3895 56.7643 67.9851 55.1687C68.5058 54.648 68.5058 53.8038 67.9851 53.2831C67.4644 52.7624 66.6202 52.7624 66.0995 53.2831C64.504 54.8786 61.776 53.7484 61.776 51.4922C61.776 50.7558 61.1791 50.1589 60.4427 50.1589ZM56.4536 51.1949C56.6057 49.1246 58.3336 47.4922 60.4427 47.4922C62.5518 47.4922 64.2797 49.1246 64.4318 51.1949C66.0033 49.8385 68.3794 49.9061 69.8707 51.3974C71.3621 52.8888 71.4296 55.2649 70.0733 56.8364C72.1436 56.9885 73.776 58.7164 73.776 60.8255C73.776 62.9347 72.1436 64.6625 70.0733 64.8146C71.4297 66.3861 71.3622 68.7622 69.8708 70.2536C68.3794 71.745 66.0033 71.8125 64.4318 70.4561C64.2798 72.5264 62.5519 74.1589 60.4427 74.1589C58.3335 74.1589 56.6057 72.5264 56.4536 70.4561C54.8821 71.8125 52.506 71.745 51.0146 70.2536C49.5232 68.7622 49.4557 66.3861 50.8121 64.8146C48.7418 64.6625 47.1094 62.9347 47.1094 60.8255C47.1094 58.7164 48.7418 56.9885 50.8122 56.8364C49.4558 55.2649 49.5232 52.8888 51.0146 51.3974C52.506 49.906 54.8821 49.8385 56.4536 51.1949Z",
    fill: "#7551FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4427 58.1589C59.7355 58.1589 59.0572 58.4398 58.5571 58.9399C58.057 59.44 57.776 60.1183 57.776 60.8255C57.776 61.5328 58.057 62.211 58.5571 62.7111C59.0572 63.2112 59.7355 63.4922 60.4427 63.4922C61.15 63.4922 61.8282 63.2112 62.3283 62.7111C62.8284 62.211 63.1094 61.5328 63.1094 60.8255C63.1094 60.1183 62.8284 59.44 62.3283 58.9399C61.8282 58.4398 61.15 58.1589 60.4427 58.1589ZM56.6715 57.0543C57.6717 56.0541 59.0282 55.4922 60.4427 55.4922C61.8572 55.4922 63.2137 56.0541 64.2139 57.0543C65.2141 58.0545 65.776 59.411 65.776 60.8255C65.776 62.24 65.2141 63.5966 64.2139 64.5968C63.2137 65.597 61.8572 66.1589 60.4427 66.1589C59.0282 66.1589 57.6717 65.597 56.6715 64.5968C55.6713 63.5966 55.1094 62.24 55.1094 60.8255C55.1094 59.411 55.6713 58.0545 56.6715 57.0543Z",
    fill: "#7551FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1209_34109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6953 60.4023) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080015",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamSetting);
export default __webpack_public_path__ + "static/media/TeamSetting.404e53b77011a3a91b65e1bd637d33d6.svg";
export { ForwardRef as ReactComponent };